import { render, staticRenderFns } from "./dashboard-icon.vue?vue&type=template&id=052454b8&scoped=true"
import script from "./dashboard-icon.vue?vue&type=script&lang=js"
export * from "./dashboard-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052454b8",
  null
  
)

export default component.exports